/**
 * Enum for endpoint to call rest api
 * @readonly
 * @enum {String}
 */
export const ENDPOINT_API = Object.freeze({
	// OAuth 2
	OAUTH_TOKEN: '/oauth/token',
	OAUTH_TOKEN_REVORK: '/oauth/tokens',
	// Me
	ME: '/me',
	// Users
	USERS: '/users',
	// Orders
	ORDERS: '/orders',
	// Product Stocks
	PRODUCT_STOCKS: '/product-stocks',
	// Product Stocks
	BRANCH_STOCKS: '/branch-stocks',
	// Brands
	BRANDS: '/brands',
	// Branches
	BRANCHES: '/branches',
	// Channels
	CHANNELS: '/channels',
	// Categories
	CATEGORIES: '/categories',
	// Stock Rules
	STOCK_ROLES: '/stock-rules',
	// Channel Rules
	CHANNEL_ROLES: '/channel-rules',
	// Online group
	BRANCH_GROUPS: '/branch-groups',
	// Dashboard
	DASHBOARD: '/dashboard',
	// Reports
	REPORTS: '/stock-reports',
	// Errors
	ERRORS: '/error-reports',
	// Audit Log
	AUDIT_LOG: '/audit-logs',
	// Hooks
	HOOKS: '/hooks',
});

export const ENV = Object.freeze({
	DEV: 'dev',
	DEVELOPMENT: 'development',
});
